import { useEffect } from 'react';

export const useDropdownScroll = ({ dropdownRef, selectedItemIndex }) => {
    useEffect(() => {
        if (!dropdownRef?.current) return;

        const container = dropdownRef.current;
        const selectedElement = container.querySelector('.selected, .selected_multi_selected');
        if (!selectedElement) return;

        if (selectedItemIndex === 0) {
            container.scrollTop = 0;
            return;
        }

        const containerTop = container.getBoundingClientRect().top;
        const containerBottom = container.getBoundingClientRect().bottom;
        const itemTop = selectedElement.getBoundingClientRect().top;
        const itemBottom = selectedElement.getBoundingClientRect().bottom;

        if (itemBottom > containerBottom) {
            // Item is below visible area — scroll down
            container.scrollTop += itemBottom - containerBottom;
        } else if (itemTop < containerTop) {
            // Item is above visible area — scroll up
            container.scrollTop -= containerTop - itemTop;
        }

    }, [dropdownRef, selectedItemIndex]);
};


